import { User } from 'lucide-react';
import InputField from './InputField';
import { clearFahrerFields, type WizardDaten } from '@/lib/mietwagen-wizard-validation';

interface Props {
  daten: WizardDaten;
  onChange: (updated: Partial<WizardDaten>) => void;
}

export default function Step1Kunde({ daten, onChange }: Props) {
  const set = (field: keyof WizardDaten, value: unknown) => onChange({ [field]: value });

  const handleFahrerAbweichend = (checked: boolean) => {
    if (!checked) {
      onChange({ ...clearFahrerFields(daten), fahrer_abweichend: false });
    } else {
      onChange({ fahrer_abweichend: true });
    }
  };

  return (
    <div className="space-y-5 p-5">
      {/* Mieter */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <User className="w-4 h-4 text-orange-600" />
          <h3 className="text-sm font-semibold">Mieter (Anspruchsteller)</h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          <InputField required label="Vorname" value={daten.mieter_vorname} onChange={v => set('mieter_vorname', v)} />
          <InputField required label="Nachname" value={daten.mieter_nachname} onChange={v => set('mieter_nachname', v)} />
          <InputField required label="Straße" value={daten.mieter_strasse} onChange={v => set('mieter_strasse', v)} />
          <InputField required label="PLZ" value={daten.mieter_plz} onChange={v => set('mieter_plz', v)} />
          <InputField required label="Ort" value={daten.mieter_ort} onChange={v => set('mieter_ort', v)} />
          <InputField label="Telefon" value={daten.mieter_telefon} onChange={v => set('mieter_telefon', v)} type="tel" />
          <InputField label="E-Mail" value={daten.mieter_email} onChange={v => set('mieter_email', v)} type="email" />
          <InputField required label="Geburtsdatum" value={daten.mieter_geburtsdatum} onChange={v => set('mieter_geburtsdatum', v)} type="date" />
          <InputField required label="Führerschein-Nr." value={daten.mieter_fuehrerschein_nr} onChange={v => set('mieter_fuehrerschein_nr', v)} />
        </div>
      </div>

      {/* Abweichender Fahrer */}
      <div>
        <label className="flex items-center gap-2 mb-3 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={daten.fahrer_abweichend}
            onChange={e => handleFahrerAbweichend(e.target.checked)}
            className="w-4 h-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"
          />
          <span className="text-sm font-semibold">Fahrer abweichend vom Mieter</span>
        </label>

        {daten.fahrer_abweichend && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 pl-6 pt-1">
            <InputField required label="Vorname" value={daten.fahrer_vorname} onChange={v => set('fahrer_vorname', v)} />
            <InputField required label="Nachname" value={daten.fahrer_nachname} onChange={v => set('fahrer_nachname', v)} />
            <InputField required label="Führerschein-Nr." value={daten.fahrer_fuehrerschein_nr} onChange={v => set('fahrer_fuehrerschein_nr', v)} />
            <InputField required label="Geburtsdatum" value={daten.fahrer_geburtsdatum} onChange={v => set('fahrer_geburtsdatum', v)} type="date" />
          </div>
        )}
      </div>
    </div>
  );
}
